import { tryUseNuxtApp } from '#app'

export const getAppHost = () => {
  const nuxtApp = tryUseNuxtApp()
  if (nuxtApp) {
    const config = useRuntimeConfig()
    if (config?.public?.apiHost) return config.public.apiHost
  }
  if (process.env.NUXT_PUBLIC_API_HOST) return process.env.NUXT_PUBLIC_API_HOST
  if (process.env.APP_API_HOST) return process.env.APP_API_HOST
  return 'https://preapi.lifepage.cc'
}

export const getDefaultAvatarId = () => {
  const nuxtApp = tryUseNuxtApp()
  if (nuxtApp) {
    const config = useRuntimeConfig()
    if (config?.public?.defaultAvatarId) return config.public.defaultAvatarId
  }
  if (process.env.NUXT_PUBLIC_DEFAULT_AVATAR_ID) return process.env.NUXT_PUBLIC_DEFAULT_AVATAR_ID
  if (process.env.DEFAULT_AVATAR) return process.env.DEFAULT_AVATAR
  return '227052631233794048'
}
